import * as S from "./StandardBar.style";

interface StandardBarProps {
  shade?: boolean;
  current: number;
}

export const StandardBar = ({ shade = false, current }: StandardBarProps) => {
  return (
    <S.BarMaxBox $shade={shade}>
      <S.BarCurrent $current={current}></S.BarCurrent>
    </S.BarMaxBox>
  );
};
